import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import React from 'react';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '../formikFormInputs';
import { useAuth } from '../../lib/useAuth';
import { IrrStatus } from '../../utils/enums';


type ImoRow = {
  irr: any;
  id?: number | null;
  name: string;
  carriers: { carrierName: string }[];
}

type ImosTableProps = {
  rows: ImoRow[];
  onAddNewImo: () => void;
  onDelete: (index: number) => void;
  label: string;
  isDisabled: boolean;
}

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableHead: {
    backgroundColor: '#EDF3F8'
  },
});

export function ImosTable({rows, onAddNewImo, onDelete, label, isDisabled}: ImosTableProps) {
  const classes = useStyles();
  const {user} = useAuth();
  return (
    <>
      <TableContainer>
        <Table aria-label="simple table" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHead}>IMO</TableCell>
              <TableCell className={classes.tableHead} align="center">Carriers</TableCell>
              {
                !user &&
                <TableCell className={classes.tableHead} align="center">Actions</TableCell>
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {
              rows && rows.length === 0 &&
              <TableRow>
                <TableCell align="center" className="textLeftXs" colSpan={!user ? 3 : 2}>
                  <Typography className="displayInlinexs" variant="caption" style={{display:'inline-flex',alignItems:'center'}}>
                    One IMO and carrier is required.
                    {
                      !user &&
                      <Button color="primary" label={label} onClick={onAddNewImo} disabled={isDisabled}/>
                    }
                  </Typography>
                </TableCell>
              </TableRow>
            }
            {
              rows && rows.map((row, index) => {
                if (!row || !Object.keys(row).length) {
                  return;
                }
                if (isDisabled) {
                  onDelete(index);
                }
                return (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {row.name}
                      {
                        (
                          row.id === null ||
                          (
                            row.irr && row.irr.status &&
                            [IrrStatus.PENDING, IrrStatus.REJECTED].includes(row.irr.status)
                          )
                        ) &&
                        <span className="colorRed ml15">
                          ({(row.id === null ? IrrStatus.PENDING : row.irr.status).toLowerCase()} approval)
                        </span>
                      }
                    </TableCell>
                    <TableCell align="center">{row.carriers.map(carrier => carrier.carrierName).join(', ')}</TableCell>
                    {
                      !user &&
                      <TableCell align="center">
                        <IconButton aria-label="delete" color="secondary" onClick={() => onDelete(index)}>
                          <DeleteOutlineIcon className="colorRed" />
                        </IconButton>
                      </TableCell>
                    }
                  </TableRow>
                );
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
